import { Component, OnInit } from '@angular/core';
import {AuthService } from 'src/app/services/auth.service';
import { MarketPriceService } from 'src/app/services/market-price.service';
import { MarketPrice } from 'src/app/models/market-price';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerAddress } from 'src/app/models/customer-address';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-market-price',
  templateUrl: './market-price.component.html',
  styleUrls: ['./market-price.component.css'],
})
export class MarketPriceComponent implements OnInit {
  marketprices:MarketPrice[] = [];
  marketprice:MarketPrice = new MarketPrice();

  customers:Customer[] = [];
  customer:Customer = new Customer();
  customerAddress:CustomerAddress = new CustomerAddress();
  customerAddresses:CustomerAddress[] = [];

  loading:boolean = false;
  public addMarketPrice: boolean = true;
  public upMarketPrice: boolean = true;
  public deleteMarketPrice: boolean = true;
  public expand:boolean = false;


  constructor(private servMarketPrice:MarketPriceService, private autServ:AuthService, private modalService:NgbModal, private custServ:CustomerService, private utl:UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.servMarketPrice.getMarketPrices().then(marketprices => {
      this.marketprices = marketprices;
      this.loading = false;
    });

    
    this.custServ.getCustomers().then(customers => {
      this.customers = customers.filter(cust => cust.type != 'Compañia');
      this.customer = this.customers[0];
      this.customerAddresses = this.customers[0].directions;
      this.customerAddress = this.customerAddresses[0];
    });
    
    this.addMarketPrice = this.autServ.can('store-market-price');
    this.upMarketPrice = this.autServ.can('update-market-price');
    this.deleteMarketPrice = this.autServ.can('destroy-market-price');
  }

  select(modal?, marketprice?:MarketPrice){
    if(marketprice){
      this.marketprice = marketprice;

      this.customer = this.customers.find(cust => cust.id == this.marketprice.customer_id);
      this.customerAddresses = this.customer.directions;
      this.customerAddress = this.customerAddresses.find(add => add.id == this.marketprice.customer_address_id);
    } else {
      this.marketprice = new MarketPrice();

      this.customer = this.customer[0];
      this.customerAddresses = this.customers[0].directions;
      this.customerAddress = this.customerAddresses[0];
    }
    if(modal){
      this.modalService.open(modal, {size: 'lg'});
    }
  }

  changeCustomer() {
    this.customerAddresses = this.customer.directions;
    this.customerAddress = this.customerAddresses[0];
  }

  asignarClientes() {
    this.marketprice.customer_address_id = this.customerAddress.id;
    this.marketprice.customer_id = this.customer.id;
  }

  storeMarketPrice (event){
    event.preventDefault();

    this.asignarClientes();
    
    this.loading = true;

    this.servMarketPrice.postMarketPrice(this.marketprice)
    .then(res => {
      this.toastr.successToastr('Creado Correctmanente');
      this.marketprices.push(res);
      this.loading = false;
    })
    .catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  updateMarketPrice(event) {
    event.preventDefault();

    this.asignarClientes();

    this.loading = true;

    this.servMarketPrice.putMarketPrice(this.marketprice)
      .then(res => {
        this.toastr.successToastr('Actualizado Correctmanente');
        this.loading = false;
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

  MarketPricedelete(){
    this.loading = true;
    this.servMarketPrice.deleteMarketPrice(this.marketprice)
    .then(res => {
      this.toastr.successToastr('Eliminado Correctmanente');
      this.marketprices  = this.marketprices.filter(mp => mp != this.marketprice);
      this.loading = false;
    });
  }

}
